<div class="toggle" (click)="toggle()">
    <span class="ball" [ngClass]="{'active': this.active, 'inactive': !this.active}"></span>
  </div>
